module.exports = __webpack_public_path__ + "static/media/hingeBottomImg3.334b0d19.png";